import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"

import { cn } from "../lib/utils"

interface RadioGroupProps
  extends React.ComponentProps<typeof RadioGroupPrimitive.Root> {
  direction?: "row" | "column"
}

function RadioGroup({
  className,
  direction = "column",
  ...props
}: RadioGroupProps) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn(
        "flex",
        direction === "column" ? "flex-col gap-3 cursor-pointer" : "flex-row gap-4 cursor-pointer",
        className
      )}
      {...props}
    />
  )
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "group cursor-pointer aspect-square size-4 shrink-0 rounded-full border border-secondary shadow-xs",
        "transition-[color,box-shadow] outline-none",
        "focus-visible:ring-secondary focus-visible:ring-[3px] focus-visible:ring-offset-0",
        "focus-visible:border-secondary",
        "hover:border-primary-700",
        "data-[state=checked]:border-primary data-[state=checked]:disabled:border-bg-200",
        "aria-invalid:ring-error-500/20 dark:aria-invalid:ring-error-500/40 aria-invalid:border-error-500",
        "dark:bg-background/30",
        "disabled:cursor-not-allowed disabled:border-stroke-500 disabled:bg-bg-100",
        "data-[state=checked]:disabled:bg-transparent", /* No background when checked & disabled */
        "data-[state!=checked]:disabled:bg-bg-100", /* Background when unchecked & disabled */

        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center cursor-pointer"
      >
        {/* <CircleIcon className="fill-primary absolute top-1/2 left-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2" /> */}
        <div className="h-2 w-2 rounded-full bg-primary group-disabled:group-data-[state=checked]:bg-disabled2" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
